import { apiClient } from "@/lib/api-client";
import type { RsvpResponse } from "@/src/features/wedding/types";
import type { RsvpFormValues } from "@/src/features/wedding/schemas/rsvp-schema";

export async function submitRsvp(payload: RsvpFormValues): Promise<RsvpResponse> {
  return apiClient.post<RsvpResponse>("/rsvp", payload);
}
